import React, { Component } from 'react';
import { View, Image, StyleSheet } from 'react-native';

import LoginForm from './LoginForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import PasswordResetForm from './App/PasswordResetForm';
import {
  getInitialParams,
  updateInitialParams,
} from '../support/InitialParams';
import DataStore from '../support/DataStore';
import { Text, Link } from './uiold';
import { themeColors } from './uiold/Constants';

const PASSWORD_RESET = 'password-reset';
const dataStore = DataStore.getInstance('app');

type Props = {
  _?: never;
};

type State = {
  showForgotPasswordForm: boolean;
  changePasswordFormData: ReturnType<typeof parseParams>;
};

class LandingPage extends Component<Props, State> {
  state: State = {
    showForgotPasswordForm: false,
    changePasswordFormData: parseParams(getInitialParams()),
  };

  render() {
    let { showForgotPasswordForm, changePasswordFormData } = this.state;
    let content = (
      <LoginForm
        onLoginSuccess={(account, user) => {
          dataStore.set('user', user);
          dataStore.set('account', account);
        }}
        onForgotPasswordClick={() => {
          this.setState({ showForgotPasswordForm: true });
        }}
      />
    );

    if (changePasswordFormData) {
      content = (
        <PasswordResetForm
          changePasswordData={changePasswordFormData}
          onSuccess={() => {
            updateInitialParams((params) => {
              let newParams = { ...params };
              delete newParams[PASSWORD_RESET];
              return newParams;
            });
            this.setState({ changePasswordFormData: null });
          }}
          onBackToLogin={() => {
            this.setState({ changePasswordFormData: null });
          }}
        />
      );
    } else if (showForgotPasswordForm) {
      content = (
        <ForgotPasswordForm
          onBackToLogin={() => {
            this.setState({ showForgotPasswordForm: false });
          }}
        />
      );
    }
    return (
      <View style={styles.root}>
        <Image
          style={styles.logo}
          source={{ uri: '/assets/images/logo-wide-outline.svg' }}
          accessibilityLabel={t('MarketWurks Logo')}
        />
        <View style={styles.contentContainer}>{content}</View>
        <View style={styles.copyrightContainer}>
          <Text style={styles.copyright}>
            {t.jsx(
              '©{year} <link>marketwurks.com</link>. All Rights Reserved.',
              {
                year: new Date().getFullYear(),
                link: (content) => (
                  <Link
                    style={{ color: themeColors.blue }}
                    href="https://marketwurks.com/"
                  >
                    {content}
                  </Link>
                ),
              },
            )}
          </Text>
        </View>
      </View>
    );
  }
}

function parseParams(params: ObjectOf<unknown>) {
  let value = params[PASSWORD_RESET];
  if (typeof value === 'string') {
    let [token = '', id = ''] = value.split('-');
    return { token, id };
  } else {
    return null;
  }
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: themeColors.landingPageBackground,
  },
  logo: {
    margin: 40,
    width: 400,
    height: 63,
  },
  copyright: {
    alignItems: 'center',
    marginBottom: 30,
    padding: 10,
    fontSize: 13,
    color: themeColors.copyright,
  },
  copyrightContainer: {
    alignItems: 'center',
    marginBottom: 150,
    padding: 10,
  },
  contentContainer: {
    backgroundColor: themeColors.landingPageContainer,
    borderRadius: 7,
    width: 400,
  },
});

export default LandingPage;
